goog.module('yext.storm.AccountDropdown');
goog.module.declareLegacyNamespace();

const routes = goog.require('yext.storm.routes');

$(document).ready(function() {
  // Attach searcher
  var timeout;
  var xhr;
  var originalResults = $('#account-dropdown-results').html();
  $('#account-dropdown-searcher').keyup(function(e) {
    var val = $('#account-dropdown-searcher').val();
    clearTimeout(timeout);
    if (xhr) {
      xhr.abort();
    }
    if (val.length > 0) {
      $('#account-dropdown-results').empty().append($('.accounts-loading').clone().show());
      timeout = setTimeout(function() {
        xhr = $.ajax({
          url: routes.MainDropdown.getDropdownAccounts({'query': val}),
          success: function(data) {
            $('#account-dropdown-results').html(data);
          },
        });
      }, 200);
    } else {
      $('#account-dropdown-results').empty().append(originalResults);
    }
  });

  var $systemAlertsEl = $('.js-nav-system-alerts');
  var loadSystemAlerts = function() {
    $.ajax({
      url: routes.Root.systemAlerts(),
      success: function(html) {
        $systemAlertsEl.html(html);
      },
    });
  };
  var systemAlertsElementPresent = $systemAlertsEl.length;
  var systemAlertsAlreadyLoaded = $('#alertsmenu').length != 0;
  if (systemAlertsElementPresent && !systemAlertsAlreadyLoaded) {
    loadSystemAlerts();
  }

  goog.exportSymbol('loadSystemAlerts', loadSystemAlerts);
});

